import { sortParticipantsByVenueRole } from "sb-resp-utils";
export var mapTeamNames = function (x) {
    x.participants.sort(sortParticipantsByVenueRole);
    var swapArray = x.isTeamSwap ? [1, 0] : [0, 1];
    x.team1name = x.participants[swapArray[0]].name;
    x.team2name = x.participants[swapArray[1]].name;
    return x;
};
//# sourceMappingURL=mapTeamNames.js.map